import { render, staticRenderFns } from "./CreateImport.vue?vue&type=template&id=52042805&scoped=true&"
import script from "./CreateImport.vue?vue&type=script&lang=js&"
export * from "./CreateImport.vue?vue&type=script&lang=js&"
import style0 from "./CreateImport.vue?vue&type=style&index=0&id=52042805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52042805",
  null
  
)

export default component.exports